import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gtr-lite w-100 position-relative" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "text-uppercase card-title-row" }
const _hoisted_4 = { class: "card-background d-flex flex-column position-relative h-100" }
const _hoisted_5 = { class: "card-body d-flex flex-column flex-grow-1 position-relative" }
const _hoisted_6 = { class: "d-flex justify-content-center" }
const _hoisted_7 = { class: "list-unstyled text-dark fw-bold" }
const _hoisted_8 = { class: "card-footer position-relative text-white text-center" }
const _hoisted_9 = { class: "initial-price text-nowrap" }
const _hoisted_10 = { class: "text-nowrap" }
const _hoisted_11 = {
  key: 0,
  class: "card-action d-flex position-relative justify-content-center mt-4"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_package_icon = _resolveComponent("package-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "background-border" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_package_icon, { product: "gtr-go" }),
        _createElementVNode("span", null, _toDisplayString(_ctx.subscriptionName || _ctx.SubscriptionConfig.displayName), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-body-title text-center text-uppercase text-danger fw-bold mb-3 fs-4" }, "Beneficios perdidos:", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lostBenefits, (benefit) => {
              return (_openBlock(), _createElementBlock("li", { key: benefit }, [
                _cache[1] || (_cache[1] = _createElementVNode("i", {
                  class: "fa fa-times text-danger me-1",
                  "aria-hidden": "true"
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(benefit), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "card-footer-title" }, "Costo", -1)),
          _cache[4] || (_cache[4] = _createTextVNode("  ", -1)),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.SubscriptionConfig.renewalCost || _ctx.SubscriptionConfig.cost) + " " + _toDisplayString(_ctx.SubscriptionConfig.currency), 1),
          _createElementVNode("span", _hoisted_10, " / " + _toDisplayString(_ctx.SubscriptionConfig.duration) + " " + _toDisplayString(_ctx.SubscriptionDurationUnitLocalized), 1)
        ])
      ]),
      (!_ctx.isOffline)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-lg gtr-lite-btn",
              type: "button",
              disabled: _ctx.isQuoting,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.subscriptionQuote()))
            }, [
              _cache[5] || (_cache[5] = _createTextVNode("Inscribirse ", -1)),
              (_ctx.isQuoting)
                ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                : _createCommentVNode("", true)
            ], 8, _hoisted_12)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}